import { Injectable, NgZone } from '@angular/core'
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  SimpleSnackBar,
} from '@angular/material/snack-bar'

import { SnackBarComponent } from './snack-bar.component'

@Injectable({ providedIn: 'root' })
export class SnackBarService {
  private readonly horizontalPosition: MatSnackBarHorizontalPosition = 'center'
  private readonly verticalPosition: MatSnackBarVerticalPosition = 'bottom'

  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly zone: NgZone,
  ) {}

  private openSnackBar(data: any, config?: MatSnackBarConfig): void {
    const snackBarConfig: MatSnackBarConfig<SimpleSnackBar> = {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      data,
      ...config,
    }

    this.zone.run(() => this.snackBar.openFromComponent(SnackBarComponent, snackBarConfig))
  }

  closeSnackBar(): void {
    this.snackBar.dismiss()
  }

  notificationArrived(message: string): void {
    this.openSnackBar(message, {
      panelClass: 'snack-bar-notification',
      duration: 4000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    })
  }

  success(message: string, duration = 2500): void {
    this.openSnackBar(message, {
      panelClass: ['snack-bar-base', 'snack-bar-success'],
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    })
  }

  error(message: string, duration = 5000): void {
    this.openSnackBar(message, {
      panelClass: ['snack-bar-base', 'snack-bar-error'],
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    })
  }

  warning(message: string, duration = 4000): void {
    this.openSnackBar(message, {
      panelClass: ['snack-bar-base', 'snack-bar-warning'],
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    })
  }

  info(message: string, duration = 3000): void {
    this.openSnackBar(message, {
      panelClass: ['snack-bar-base', 'snack-bar-info'],
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    })
  }
}
